/* eslint-disable @typescript-eslint/no-explicit-any */
export const debug = (data: any) => {
  if (window?.document && ('' + window?.location?.host)?.indexOf('.dev') !== -1) console.log(data)
}
